import { render, staticRenderFns } from "./MandatsByGuichet.vue?vue&type=template&id=636faf6a&"
import script from "./MandatsByGuichet.vue?vue&type=script&lang=js&"
export * from "./MandatsByGuichet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports